export const positionList = [
  {
    children: [
      {
        children: [
          { text: "ARAMANGO" },
          { text: "COPALLIN" },
          { text: "EL PARCO" },
          { text: "IMAZA" },
          { text: "LA PECA" },
        ],
        text: "BAGUA",
      },
      {
        children: [
          { text: "CHISQUILLA" },
          { text: "CHURUJA" },
          { text: "COROSHA" },
          { text: "CUISPES" },
          { text: "FLORIDA" },
          { text: "JAZAN" },
          { text: "JUMBRILLA" },
          { text: "RECTA" },
          { text: "SAN CARLOS" },
          { text: "SHIPASBAMBA" },
          { text: "VALERA" },
          { text: "YAMBRASBAMBA" },
        ],
        text: "BONGARA",
      },
      {
        children: [
          { text: "ASUNCION" },
          { text: "BALSAS" },
          { text: "CHACHAPOYAS" },
          { text: "CHETO" },
          { text: "CHILIQUIN" },
          { text: "CHUQUIBAMBA" },
          { text: "GRANADA" },
          { text: "HUANCAS" },
          { text: "LA JALCA" },
          { text: "LEIMEBAMBA" },
          { text: "LEVANTO" },
          { text: "MAGDALENA" },
          { text: "MARISCAL CASTILLA" },
          { text: "MOLINOPAMPA" },
          { text: "MONTEVIDEO" },
          { text: "OLLEROS" },
          { text: "QUINJALCA" },
          { text: "SAN FRANCISCO DE DAGUAS" },
          { text: "SAN ISIDRO DE MAINO" },
          { text: "SOLOCO" },
          { text: "SONCHE" },
        ],
        text: "CHACHAPOYAS",
      },
      {
        children: [
          { text: "EL CENEPA" },
          { text: "NIEVA" },
          { text: "RIO SANTIAGO" },
        ],
        text: "CONDORCANQUI",
      },
      {
        children: [
          { text: "CAMPORREDONDO" },
          { text: "COCABAMBA" },
          { text: "COLCAMAR" },
          { text: "CONILA" },
          { text: "INGUILPATA" },
          { text: "LAMUD" },
          { text: "LONGUITA" },
          { text: "LONYA CHICO" },
          { text: "LUYA" },
          { text: "LUYA VIEJO" },
          { text: "MARIA" },
          { text: "OCALLI" },
          { text: "OCUMAL" },
          { text: "PISUQUIA" },
          { text: "PROVIDENCIA" },
          { text: "SAN CRISTOBAL" },
          { text: "SAN FRANCISCO DEL YESO" },
          { text: "SAN JERONIMO" },
          { text: "SAN JUAN DE LOPECANCHA" },
          { text: "SANTA CATALINA" },
          { text: "SANTO TOMAS" },
          { text: "TINGO" },
          { text: "TRITA" },
        ],
        text: "LUYA",
      },
      {
        children: [
          { text: "CHIRIMOTO" },
          { text: "COCHAMAL" },
          { text: "HUAMBO" },
          { text: "LIMABAMBA" },
          { text: "LONGAR" },
          { text: "MARISCAL BENAVIDES" },
          { text: "MILPUC" },
          { text: "OMIA" },
          { text: "SAN NICOLAS" },
          { text: "SANTA ROSA" },
          { text: "TOTORA" },
          { text: "VISTA ALEGRE" },
        ],
        text: "RODRIGUEZ DE MENDOZA",
      },
      {
        children: [
          { text: "BAGUA GRANDE" },
          { text: "CAPARURO" },
          { text: "CUMBA" },
          { text: "EL MILAGRO" },
          { text: "JAMALCA" },
          { text: "LONYA GRANDE" },
          { text: "YAMON" },
        ],
        text: "UTUBAMBA",
      },
    ],
    text: "AMAZONAS",
  },
  {
    children: [
      {
        children: [
          { text: "AIJA" },
          { text: "CORIS" },
          { text: "HUACLLAN" },
          { text: "LA MERCED" },
          { text: "SUCCHA" },
        ],
        text: "AIJA",
      },
      {
        children: [
          { text: "ACZO" },
          { text: "CHACCHO" },
          { text: "CHINGAS" },
          { text: "LLAMELLIN" },
          { text: "MIRGAS" },
          { text: "SAN JUAN DE RONTOY" },
        ],
        text: "ANTONIO RAYMONDI",
      },
      {
        children: [{ text: "ACOCHACAS" }, { text: "CHACAS" }],
        text: "ASUNCION",
      },
      {
        children: [
          { text: "ABELARDO PARDO LEZAMETA" },
          { text: "ANTONIO RAYMONDI" },
          { text: "AQUIA" },
          { text: "CAJACAY" },
          { text: "CANIS" },
          { text: "CHIQUIAN" },
          { text: "COLQUIOC" },
          { text: "HUALLANCA" },
          { text: "HUASTA" },
          { text: "HUAYLLACAYAN" },
          { text: "LA PRIMAVERA" },
          { text: "MANGAS" },
          { text: "PACLLON" },
          { text: "SAN MIGUEL DE CORPANQUI" },
          { text: "TICLLOS" },
        ],
        text: "BOLOGNESI",
      },
      {
        children: [
          { text: "ACOPAMPA" },
          { text: "AMASHCA" },
          { text: "ANTA " },
          { text: "ATAQUERO" },
          { text: "CARHUAZ" },
          { text: "MARCARA" },
          { text: "PARIAHUANCA" },
          { text: "SAN MIGUEL DE ACO" },
          { text: "SHILLA" },
          { text: "TICO" },
          { text: "YUNGAR" },
        ],
        text: "CARHUAZ",
      },
      {
        children: [
          { text: "SAN LUIS" },
          { text: "SAN NICOLAS" },
          { text: "YAUYA" },
        ],
        text: "CARLOS DE FERMIN FITZCARRALD",
      },
      {
        children: [
          { text: "BUENA VISTA ALTA" },
          { text: "CASMA" },
          { text: "COMANDANTE NOEL" },
          { text: "YAUTAN" },
        ],
        text: "CASMA",
      },
      {
        children: [
          { text: "ACO" },
          { text: "BAMBAS" },
          { text: "CORONGO" },
          { text: "CUSCA" },
          { text: "LA PAMPA" },
          { text: "YANAC" },
          { text: "YUPAC" },
        ],
        text: "CORONGO",
      },
      {
        children: [
          { text: "COCHABAMBA" },
          { text: "COLCABAMBA" },
          { text: "HUANCHAY" },
          { text: "HUARAZ" },
          { text: "INDEPENDENCIA" },
          { text: "JANGAS" },
          { text: "LA LIBERTAD" },
          { text: "OLLEROS" },
          { text: "PAMPAS" },
          { text: "PARIACOTO" },
          { text: "PIRA" },
          { text: "TARICA" },
        ],
        text: "HUARAZ",
      },
      {
        children: [
          { text: "ANRA" },
          { text: "CAJAY" },
          { text: "CHAVIN DE HUANTAR" },
          { text: "HUACACHI" },
          { text: "HUACCHIS" },
          { text: "HUACHIS" },
          { text: "HUANTAR" },
          { text: "HUARI" },
          { text: "MASIN" },
          { text: "PAUCAS" },
          { text: "PONTO" },
          { text: "RAHUAPAMPA" },
          { text: "RAPAYAN" },
          { text: "SAN MARCOS" },
          { text: "SAN PEDRO DE CHANA" },
          { text: "UCO" },
        ],
        text: "HUARI",
      },
      {
        children: [
          { text: "COCHAPETI" },
          { text: "CULEBRAS" },
          { text: "HUARMEY" },
          { text: "HUAYAN" },
          { text: "MALVAS" },
        ],
        text: "HUARMEY",
      },
      {
        children: [
          { text: "CARAZ" },
          { text: "HUALLANCA" },
          { text: "HUATA" },
          { text: "HUAYLAS" },
          { text: "MATO" },
          { text: "PAMPAROMAS" },
          { text: "PUEBLO LIBRE" },
          { text: "SANTA CRUZ" },
          { text: "SANTO TORIBIO" },
          { text: "YURACMARCA" },
        ],
        text: "HAYLAS",
      },
      {
        children: [
          { text: "CASCA" },
          { text: "ELEAZAR GUZMAN BARRON" },
          { text: "FIDEL OLIVAS ESCUDERO" },
          { text: "LLAMA" },
          { text: "LLUMPA" },
          { text: "LUCMA" },
          { text: "MUSGA" },
          { text: "PISCOBAMBA" },
        ],
        text: "MARISCAL LUZURIAGA",
      },
      {
        children: [
          { text: "ACAS" },
          { text: "CAJAMARQUILLA" },
          { text: "CARHUAPAMPA" },
          { text: "COCHAS" },
          { text: "CONGAS" },
          { text: "LLIPA" },
          { text: "OCROS" },
          { text: "SAN CRISTOBAL DE RAJAN" },
          { text: "SAN PEDRO " },
          { text: "SANTIAGO DE CHILCAS" },
        ],
        text: "OCROS",
      },
      {
        children: [
          { text: "BOLOGNESI" },
          { text: "CABANA" },
          { text: "CONCHUCOS" },
          { text: "HUACASCHUQUE" },
          { text: "HUANDOVAL" },
          { text: "LACABAMBA" },
          { text: "LLAPO" },
          { text: "PALLASCA" },
          { text: "PAMPAS" },
          { text: "SANTA ROSA" },
          { text: "TAUCA" },
        ],
        text: "PALLASCA",
      },
      {
        children: [
          { text: "HUAYLLAN" },
          { text: "PAROBAMBA" },
          { text: "POMABAMBA" },
          { text: "QUINUABAMBA" },
        ],
        text: "POMABAMBA",
      },
      {
        children: [
          { text: "CATAC" },
          { text: "COTAPARACO" },
          { text: "HUAYLLAPAMPA" },
          { text: "LLACLLIN" },
          { text: "MARCA" },
          { text: "PAMPAS CHICO" },
          { text: "PARARIN" },
          { text: "RECUAY" },
          { text: "TAPACOCHA" },
          { text: "TICAPAMPA" },
        ],
        text: "RECUAY",
      },
      {
        children: [
          { text: "CACERES DEL PERU" },
          { text: "CHIMBOTE" },
          { text: "COISHCO" },
          { text: "MACATE" },
          { text: "MORO" },
          { text: "NEPEÑA" },
          { text: "NUEVO CHIMBOTE" },
          { text: "SAMANCO" },
          { text: "SANTA" },
        ],
        text: "SANTA",
      },
      {
        children: [
          { text: "ACOBAMBA" },
          { text: "ALFONSO UGARTE" },
          { text: "CASHAPAMPA" },
          { text: "CHINGALPO" },
          { text: "HUAYLLABAMBA" },
          { text: "QUICHES" },
          { text: "RAGASH" },
          { text: "SAN JUAN" },
          { text: "SICSIBAMBA" },
          { text: "SIHUAS" },
        ],
        text: "SIHUAS",
      },
      {
        children: [
          { text: "CASCAPARA" },
          { text: "MANCOS" },
          { text: "MATACOTO" },
          { text: "QUILLO" },
          { text: "RANRAHIRCA" },
          { text: "SHUPLUY" },
          { text: "YANAMA" },
          { text: "YUNGAY" },
        ],
        text: "YUNGAY",
      },
    ],
    text: "ANCASH",
  },
  {
    children: [
      {
        children: [
          { text: "ABANCAY" },
          { text: "CHACOCHE" },
          { text: "CIRCA" },
          { text: "CURAHUASI" },
          { text: "HUANIPACA" },
          { text: "LAMBRAMA" },
          { text: "PICHIRHUA" },
          { text: "SAN PEDRO DE CCACHORA" },
          { text: "TAMBURCO" },
        ],
        text: "ABANCAY",
      },
      {
        children: [
          { text: "ANDAHUAYLAS" },
          { text: "ANDARAPA" },
          { text: "CHIARA" },
          { text: "HUANCARAMA" },
          { text: "HUANCARAY" },
          { text: "HUAYANA" },
          { text: "KAQUIABAMBA" },
          { text: "KISHUARA" },
          { text: "PACOBAMBA" },
          { text: "PACUCHA" },
          { text: "PAMPACHIRI" },
          { text: "POMACOCHA" },
          { text: "SAN ANTONIO DE CACHI" },
          { text: "SAN JERONIMO" },
          { text: "SAN MIGUEL DE CHACCRAMPA" },
          { text: "SANTA MARIA DE CHICMO" },
          { text: "TALAVERA" },
          { text: "TUMAY HUARACA" },
          { text: "TURPO" },
        ],
        text: "ANDAHUAYLAS",
      },
      {
        children: [
          { text: "ANTABAMBA" },
          { text: "EL ORO" },
          { text: "HUAQUIRCA" },
          { text: "JUAN ESPINOZA MEDRANO" },
          { text: "OROPESA" },
          { text: "PACHACONAS" },
          { text: "SABAINO" },
        ],
        text: "ANTABAMBA",
      },
      {
        children: [
          { text: "CAPAYA" },
          { text: "CARAYBAMBA" },
          { text: "CHALHUANCA" },
          { text: "CHAPIMARCA" },
          { text: "COLCABAMBA" },
          { text: "COTARUSE" },
          { text: "HUAYLLO" },
          { text: "JUSTO APU SAHUARAURA" },
          { text: "LUCRE" },
          { text: "POCOHUANCA" },
          { text: "SAN JUAN DE CHACÑA" },
          { text: "SAÑAYCA" },
          { text: "SORAYA" },
          { text: "TAPAIRIHUA" },
          { text: "TINTAY" },
          { text: "TORAYA" },
          { text: "YANACA" },
        ],
        text: "AYMARES",
      },
      {
        children: [
          { text: "ANCO HUALLO" },
          { text: "CHINCHERAS" },
          { text: "COCHARCAS" },
          { text: "HUACCANA" },
          { text: "OCOBAMBA" },
          { text: "ONGOY" },
          { text: "RANRACANCHA" },
          { text: "URANMARCA" },
        ],
        text: "CHINCHEROS",
      },
      {
        children: [
          { text: "CHALLHUAHUACHO" },
          { text: "COTABAMBAS" },
          { text: "COYLLURQUI" },
          { text: "HAQUIRA" },
          { text: "MARA" },
          { text: "TAMBOBAMBA" },
        ],
        text: "COTABAMBAS",
      },
      {
        children: [
          { text: "CHUQUIBAMBILLA" },
          { text: "CURASCO" },
          { text: "CURPAHUASI" },
          { text: "GAMARRA" },
          { text: "HAYLLATI" },
          { text: "MAMARA" },
          { text: "MICAELA BASTIDAS" },
          { text: "PATAYPAMPA" },
          { text: "PROGRESO" },
          { text: "SAN ANTONIO" },
          { text: "SANTA ROSA" },
          { text: "TURPAY" },
          { text: "VILCABAMBA" },
          { text: "VIRUNDO" },
        ],
        text: "GRAU",
      },
    ],
    text: "APURIMAC",
  },
  {
    children: [
      {
        children: [
          { text: "ALTO SELVA ALEGRE" },
          { text: "AREQUIPE" },
          { text: "CAYMA" },
          { text: "CERRO COLORADO" },
          { text: "CHARACATO" },
          { text: "CHIGUATA" },
          { text: "JACOBO HUNTER" },
          { text: "JOSE LUIS BUSTAMANTE Y RIVERO" },
          { text: "LA JOYA" },
          { text: "MARIANO MELGAR" },
          { text: "MIRAFLORES" },
          { text: "MOLLEBAYA" },
          { text: "PAUCARPATA" },
          { text: "POCSI" },
          { text: "POLOBAYA" },
          { text: "QUEQUEÑA" },
          { text: "SABANDIA" },
          { text: "SACHACA" },
          { text: "SAN JUAN DE SIGUAS" },
          { text: "SANTA ISABEL DE SIGUAS" },
          { text: "SAN JUAN DE TARUCANI" },
          { text: "SANTA RITA DE SIGUAS" },
          { text: "SOCABAYA" },
          { text: "TIABAYA" },
          { text: "UCHUMAYO" },
          { text: "VITOR" },
          { text: "YANAHUARA" },
          { text: "YARABAMBA" },
          { text: "YURA" },
        ],
        text: "AREQUIPA",
      },
      {
        children: [
          { text: "CAMANA" },
          { text: "JOSE MARIA QUIMPER" },
          { text: "MARIANO NICOLAS VALCARCEL" },
          { text: "MARISCAL CACERES" },
          { text: "NICOLAS DE PIEROLA" },
          { text: "OCOÑA" },
          { text: "QUILCA" },
          { text: "SAMUEL PASTOR" },
        ],
        text: "CAMANA",
      },
      {
        children: [
          { text: "ACARI" },
          { text: "ATICO" },
          { text: "ATIQUIPA" },
          { text: "BELLA UNION" },
          { text: "CAHUACHO" },
          { text: "CARAVELI" },
          { text: "CHALA" },
          { text: "CHAPARRA" },
          { text: "HUANUHUANU" },
          { text: "JAQUI" },
          { text: "LOMAS" },
          { text: "QUICACHA" },
          { text: "YAUCA" },
        ],
        text: "CARAVELI",
      },
      {
        children: [
          { text: "ANDAGUA" },
          { text: "APLAO" },
          { text: "AYO" },
          { text: "CHACHAS" },
          { text: "CHILCAYMARCA" },
          { text: "CHOCO" },
          { text: "HUANCARQUI" },
          { text: "MACHAGUAY" },
          { text: "ORCOPAMPA" },
          { text: "PAMPACOLCA" },
          { text: "TIPAN" },
          { text: "UÑON" },
          { text: "URACA" },
          { text: "VIRACO" },
        ],
        text: "CASTILLA",
      },
      {
        children: [
          { text: "ACHOMA" },
          { text: "CABANACONDE" },
          { text: "CALLALLI" },
          { text: "CAYLLOMA" },
          { text: "CHIVAY" },
          { text: "COPORAQUE" },
          { text: "HUAMBO" },
          { text: "HUANCA" },
          { text: "ICHUPAMPA" },
          { text: "LARI" },
          { text: "LLUTA" },
          { text: "MACA" },
          { text: "MADRIGAL" },
          { text: "MAJES" },
          { text: "SAN ANTONIO DE CHUCA" },
          { text: "SIBAYO" },
          { text: "TAPAY" },
          { text: "TISCO" },
          { text: "TUTI" },
          { text: "YANQUE" },
        ],
        text: "CAYLLOMA",
      },
      {
        children: [
          { text: "ANDARAY" },
          { text: "CAYARANI" },
          { text: "CHICHAS" },
          { text: "CHUQUIBAMBA" },
          { text: "IRAY" },
          { text: "RIO GRANDE" },
          { text: "SALAMANCA" },
          { text: "YANAQUIHUA" },
        ],
        text: "CONDESUYOS",
      },
      {
        children: [
          { text: "COCACHACRA" },
          { text: "DEAN VALDIVIA" },
          { text: "ISLAY" },
          { text: "MEJIA" },
          { text: "MOLLENDO" },
          { text: "PUNTA BOMBON" },
        ],
        text: "ISLAY",
      },
      {
        children: [
          { text: "ALCA" },
          { text: "CHARCANA" },
          { text: "COTAHUASI" },
          { text: "HUAYNACOTAS" },
          { text: "PAMPAMARCA" },
          { text: "PUYCA" },
          { text: "QUECHUALLA" },
          { text: "SAYLA" },
          { text: "TAURIA" },
          { text: "TOMEPAMPA" },
          { text: "TORO" },
        ],
        text: "LA UNION",
      },
    ],
    text: "AREQUIPA",
  },
  {
    children: [
      {
        children: [
          { text: "CANGALLO" },
          { text: "CHUSCHI" },
          { text: "LOS MOROCHUCOS" },
          { text: "MARIA PARADO DE BELLIDO" },
          { text: "PARAS" },
          { text: "TOTOS" },
        ],
        text: "CANGALLO",
      },
      {
        children: [
          { text: "ACOCRO" },
          { text: "ACOS VINCHOS" },
          { text: "ANDRES AVELINO CACERES DORREGARAY" },
          { text: "AYACUCHO" },
          { text: "CARMEN ALTO" },
          { text: "CHIARA" },
          { text: "JESUS NAZARENO" },
          { text: "OCROS" },
          { text: "PACAYCASA" },
          { text: "QUINUA" },
          { text: "SAN JOSE DE TICLLAS" },
          { text: "SAN JUAN BAUTISTA" },
          { text: "SANTIAGO DE PISCHA" },
          { text: "SOCOS" },
          { text: "TAMBILLO" },
          { text: "VINCHOS" },
        ],
        text: "HUAMANGA",
      },
      {
        children: [
          { text: "CARAPO" },
          { text: "SACSAMARCA" },
          { text: "SANCOS" },
          { text: "SANTIAGO DE LUCAMARCA" },
        ],
        text: "HUANCA SANCOS",
      },
      {
        children: [
          { text: "AYAHUANCO" },
          { text: "HUAMANGILLA" },
          { text: "HUANTA" },
          { text: "IGUAIN" },
          { text: "LLOCHEGUA" },
          { text: "LURICOCHA" },
          { text: "SANTILLANA" },
          { text: "SIVIA" },
        ],
        text: "HUANTA",
      },
      {
        children: [
          { text: "ANCHIHUAY" },
          { text: "ANCO" },
          { text: "AYNA" },
          { text: "CHILCAS" },
          { text: "CHUNGUI" },
          { text: "LUIS CARRANZA" },
          { text: "SAN MIGUEL" },
          { text: "SANTA ROSA" },
          { text: "TAMBO" },
        ],
        text: "LA MAR",
      },
      {
        children: [
          { text: "AUCARA" },
          { text: "CABANA" },
          { text: "CARMEN SALCEDO" },
          { text: "CHAVIÑA" },
          { text: "CHIPAO" },
          { text: "HUAC-HUAS" },
          { text: "LARAMATE" },
          { text: "LEONCIO PRADO" },
          { text: "LLAUTA" },
          { text: "LUCANAS" },
          { text: "OCAÑA" },
          { text: "OTOCA" },
          { text: "PUQUIO" },
          { text: "SAISA" },
          { text: "SAN CRISTOBAL" },
          { text: "SAN JUAN" },
          { text: "SAN PEDRO" },
          { text: "SAN PEDRO DE PALCO" },
          { text: "SANCOS" },
          { text: "SANTA ANA DE HUAYCAHUACHO" },
          { text: "SANTA LUCIA" },
        ],
        text: "LUCANAS",
      },
      {
        children: [
          { text: "CHUMPI" },
          { text: "CORACORA" },
          { text: "CORONEL CASTAÑEDA" },
          { text: "PACAPAUSA" },
          { text: "PULLO" },
          { text: "PUYUSCA" },
          { text: "SAN FRANCISCO DE RAVACAYCO" },
          { text: "UPAHUACHO" },
        ],
        text: "PARINACOCHAS",
      },
      {
        children: [
          { text: "COLTA" },
          { text: "CORCULLA" },
          { text: "LAMPA" },
          { text: "MARCABAMBA" },
          { text: "OYOLO" },
          { text: "PARARCA" },
          { text: "PAUSA" },
          { text: "SAN JAVIER DE ALPABAMBA" },
          { text: "SAN JOSE DE USHUA" },
          { text: "SARA SARA" },
        ],
        text: "PAUCAR DEL SARA SARA",
      },
      {
        children: [
          { text: "BELEN" },
          { text: "CHALCOS" },
          { text: "CHILCAYOC" },
          { text: "HUACAÑA" },
          { text: "MORCOLLA" },
          { text: "PAICO" },
          { text: "QUEROBAMBA" },
          { text: "SAN PEDRO DE LARCAY" },
          { text: "SAN SALVADOR DE QUIJE" },
          { text: "SANTIAGO DE PAUCARAY" },
          { text: "SORAS" },
        ],
        text: "SUCRE",
      },
      {
        children: [
          { text: "ALCAMENCA" },
          { text: "APONGO" },
          { text: "ASQUIPATA" },
          { text: "CANARIA" },
          { text: "CAYARANI" },
          { text: "COLCA" },
          { text: "HUAMANQUIQUIA" },
          { text: "HUANCAPI" },
          { text: "HUANCARAYLLA" },
          { text: "HUAYA" },
          { text: "SARHUA" },
          { text: "VILCANCHOS" },
        ],
        text: "VICTOR FAJARDO",
      },
      {
        children: [
          { text: "ACCOMARCA" },
          { text: "CARHUANCA" },
          { text: "CONCEPCION" },
          { text: "HUAMBALPA" },
          { text: "INDEPENDENCIA" },
          { text: "SAURAMA" },
          { text: "VILCAS HUAMAN" },
          { text: "VISCHONGO" },
        ],
        text: "VILCAS HUAMAN",
      },
    ],
    text: "AYACUCHO",
  },
  {
    children: [
      {
        children: [
          { text: "CACHACHI" },
          { text: "CAJABAMBA" },
          { text: "CONDEBAMBA" },
          { text: "SITACOCHA" },
        ],
        text: "CAJABAMBA",
      },
      {
        children: [
          { text: "ASUNCION" },
          { text: "CAJAMARCA" },
          { text: "CHETILLA" },
          { text: "COSPAN" },
          { text: "ENCAÑADA" },
          { text: "JESUS" },
          { text: "LLACANORA" },
          { text: "LOS BAÑOS DEL INCA" },
          { text: "MAGDALENA" },
          { text: "MATARA" },
          { text: "NAMORA" },
          { text: "SAN JUAN" },
        ],
        text: "CAJAMARCA",
      },
      {
        children: [
          { text: "CELEDIN" },
          { text: "CHUMUCH" },
          { text: "CORTEGANA" },
          { text: "HUASMIN" },
          { text: "JORGE CHAVEZ" },
          { text: "JOSE GALVEZ" },
          { text: "LA LIBERTAD DE PALLAN" },
          { text: "MIGUEL IGLESIAS" },
          { text: "OXAMARCA" },
          { text: "SOROCHUCO" },
          { text: "SUCRE" },
          { text: "UTCO" },
        ],
        text: "CELEDIN",
      },
      {
        children: [
          { text: "ANGUIA" },
          { text: "CHADIN" },
          { text: "CHALAMARCA" },
          { text: "CHIGUIRIP" },
          { text: "CHIMBAN" },
          { text: "CHOROPAMPA" },
          { text: "CHOTA" },
          { text: "COCHABAMBA" },
          { text: "CONCHAN" },
          { text: "HUAMBOS" },
          { text: "LAJAS" },
          { text: "LLAMA" },
          { text: "MIRACOSTA" },
          { text: "PACCHA" },
          { text: "PION" },
          { text: "QUEROCOTO" },
          { text: "SAN JUAN DE LICUPIS" },
          { text: "TACABAMBA" },
          { text: "TOCMOCHE" },
        ],
        text: "CHOTA",
      },
      {
        children: [
          { text: "CHILETE" },
          { text: "CONTUMAZA" },
          { text: "CUPISNIQUE" },
          { text: "GUZMANDO" },
          { text: "SAN BENITO" },
          { text: "SANTA CRUZ DE TOLED" },
          { text: "TANTARICA" },
          { text: "YONAN" },
        ],
        text: "CONTUMAZA",
      },
      {
        children: [
          { text: "CALLAYUC" },
          { text: "CHOROS" },
          { text: "CUJILLO" },
          { text: "CUTERVO" },
          { text: "LA RAMADA" },
          { text: "PIMPINGOS" },
          { text: "QUEROCOTILLO" },
          { text: "SAN ANDRES DE CUTERVO" },
          { text: "SAN JUAN DE CUTERVO" },
          { text: "SAN LUIS DE LUCMA" },
          { text: "SANTA CRUZ" },
          { text: "SANTO DOMINGO DE LA CAPILLA" },
          { text: "SANTO TOMAS" },
          { text: "SOCOTA" },
          { text: "TORIBIO CASANOVA" },
        ],
        text: "CUTERVO",
      },
      {
        children: [
          { text: "BAMBAMARCA" },
          { text: "CHUGUR" },
          { text: "HUALGAYOC" },
        ],
        text: "HUALGAYOC",
      },
      {
        children: [
          { text: "BELLAVISTA" },
          { text: "CHONTALI" },
          { text: "COLASAY" },
          { text: "HUABAL" },
          { text: "JAEN" },
          { text: "LAS PIRIAS" },
          { text: "POMAHUACA" },
          { text: "PUCARA" },
          { text: "SALLIQUE" },
          { text: "SAN FELIPE" },
          { text: "SAN JOSE DEL ALTO" },
          { text: "SANTA ROSA" },
        ],
        text: "JAEN",
      },
      {
        children: [
          { text: "CHIRINOS" },
          { text: "HUARANGO" },
          { text: "LA COIPA" },
          { text: "NAMBALLE" },
          { text: "SAN IGNACIO" },
          { text: "SAN JOSE DE LOURDES" },
          { text: "TABACONAS" },
        ],
        text: "SAN IGNACIO",
      },
      {
        children: [
          { text: "CHANCAY" },
          { text: "EDUARDO VILLANUEVA" },
          { text: "GREGORIO PITA" },
          { text: "ICHOCAN" },
          { text: "JOSE MANUEL QUIROZ" },
          { text: "JOSE SABOCAL" },
          { text: "PEDRO GALVEZ" },
        ],
        text: "SAN MARCOS",
      },
      {
        children: [
          { text: "BOLIVAR" },
          { text: "CALQUIS" },
          { text: "CATILLUC" },
          { text: "EL PRADO" },
          { text: "LA FLORIDA" },
          { text: "LLAPA" },
          { text: "NANCHOC" },
          { text: "NIEPOS" },
          { text: "SAN GREGORIO" },
          { text: "SAN MIGUEL" },
          { text: "SAN SILVESTRE DE COCHAN" },
          { text: "TONGOD" },
          { text: "UNION AGUA BLANCA" },
        ],
        text: "SAN MIGUEL",
      },
      {
        children: [
          { text: "SAN BENARDINO" },
          { text: "SAN LUIS" },
          { text: "SAN PABLO" },
          { text: "TUMBADEN" },
        ],
        text: "SAN PABLO",
      },
      {
        children: [
          { text: "ANDABAMBA" },
          { text: "CATACHE" },
          { text: "CHANCAYBAÑOS" },
          { text: "LA ESPERANZA" },
          { text: "NINABAMBA" },
          { text: "PULAN" },
          { text: "SANTA CRUZ" },
          { text: "SAUCEPAMPA" },
          { text: "SEXO" },
          { text: "UTICYACU" },
          { text: "YAUYUCAN" },
        ],
        text: "SANTA CRUZ",
      },
    ],
    text: "CAJAMARCA",
  },
  {
    children: [
      {
        children: [
          { text: "ACOMAYO" },
          { text: "ACOPIA" },
          { text: "ACOS " },
          { text: "MOSCOC LLACTA" },
          { text: "POMACANCHI" },
          { text: "RONDOCAN" },
          { text: "SANGARARA" },
        ],
        text: "ACOMAYO",
      },
      {
        children: [
          { text: "ANCAHUASI" },
          { text: "ANTA" },
          { text: "CACHIMAYO" },
          { text: "CHINCHAYPUJIO" },
          { text: "HUAROCONDO" },
          { text: "LIMATAMBO" },
          { text: "MOLLEPATA" },
          { text: "PUCYURA" },
          { text: "ZURITE" },
        ],
        text: "ANTA",
      },
      {
        children: [
          { text: "CALCA" },
          { text: "COYA" },
          { text: "LAMAY" },
          { text: "LARES" },
          { text: "PISAC" },
          { text: "SAN SALVADOR" },
          { text: "TARAY" },
          { text: "YANATILE" },
        ],
        text: "CALCA",
      },
      {
        children: [
          { text: "CHECACUPE" },
          { text: "COMBAPATA" },
          { text: "MARANGANI" },
          { text: "PITUMARCA" },
          { text: "SAN PABLO" },
          { text: "SAN PEDRO" },
          { text: "SICUANI" },
          { text: "TINTA" },
        ],
        text: "CANCHIS",
      },
      {
        children: [
          { text: "CHECCA" },
          { text: "KUNTURKANKI" },
          { text: "LANGUI" },
          { text: "LAYO" },
          { text: "PAMPAMARCA" },
          { text: "QUEHUE" },
          { text: "TUPAC AMARLI" },
          { text: "YANAOCA" },
        ],
        text: "CANAS",
      },
      {
        children: [
          { text: "CAPACMARCA" },
          { text: "CHAMACA" },
          { text: "COLQUEMARCA" },
          { text: "LIVITACA" },
          { text: "LLUSCO" },
          { text: "QUIÑOTA" },
          { text: "SANTO TOMAS" },
          { text: "VELILE" },
        ],
        text: "CHUMBIVILCAS",
      },
      {
        children: [
          { text: "CCORCA" },
          { text: "CUSCO" },
          { text: "POROY" },
          { text: "SAN JERONIMO" },
          { text: "SAN SEBASTIAN" },
          { text: "SANTIAGO" },
          { text: "SAYLLA" },
          { text: "WANCHAQ" },
        ],
        text: "CUSCO",
      },
      {
        children: [
          { text: "ALTO PICHIGUA" },
          { text: "CONDOROMA" },
          { text: "COPORAQUE" },
          { text: "ESPINAR" },
          { text: "OCORURO" },
          { text: "PALLPATA" },
          { text: "PICHIGUA" },
          { text: "SUYCKUTAMBO" },
        ],
        text: "ESPINAR",
      },
      {
        children: [
          { text: "ECHARATE" },
          { text: "HUAYOPATA" },
          { text: "KIMBIRI" },
          { text: "MARANURA" },
          { text: "OCOBAMBA" },
          { text: "PICHARI" },
          { text: "QUELLOUNO" },
          { text: "SANTA ANA" },
          { text: "SANTA TERESA" },
          { text: "VILCABAMBA" },
        ],
        text: "LA CONVENCION",
      },
      {
        children: [
          { text: "ACCHA" },
          { text: "CCAPI" },
          { text: "COLCHA" },
          { text: "HUANOQUITE" },
          { text: "OMACHA" },
          { text: "PACCARITAMBO" },
          { text: "PARURO" },
          { text: "PILLPINTO" },
          { text: "YAURISQUE" },
        ],
        text: "PARURO",
      },
      {
        children: [
          { text: "CAICAY" },
          { text: "CHALLABAMBA" },
          { text: "COLQUEPATA" },
          { text: "HUANCARANI" },
          { text: "KOSÑIPATA" },
          { text: "PAUCARTAMBO" },
        ],
        text: "PAUCARTAMBO",
      },
      {
        children: [
          { text: "ANDAHUAYLILLAS" },
          { text: "CAMANTI" },
          { text: "CCARHUAYO" },
          { text: "CCATCA" },
          { text: "CUSIPATA" },
          { text: "HUARO" },
          { text: "LUCRE" },
          { text: "MARCAPATA" },
          { text: "OCONGATE" },
          { text: "OROPESA" },
          { text: "QUIQUIJANA" },
          { text: "URCOS" },
        ],
        text: "QUISPICANCHI",
      },
      {
        children: [
          { text: "CHINCHERO" },
          { text: "HUAYLLABAMBA" },
          { text: "MACHUPICCHU" },
          { text: "MARAS" },
          { text: "OLLANTAYTAMBO" },
          { text: "URUBAMBA" },
          { text: "YUCAY" },
        ],
        text: "URUBAMBA",
      },
    ],
    text: "CUSCO",
  },
  {
    children: [
      {
        children: [
          { text: "ACOBAMBA" },
          { text: "ANDABAMBA" },
          { text: "ANTA" },
          { text: "CAJA" },
          { text: "MARCAS" },
          { text: "PAUCARA" },
          { text: "POMACOCHA" },
          { text: "ROSARIO" },
        ],
        text: "ACOBAMBA",
      },
      {
        children: [
          { text: "ANCHONGA" },
          { text: "CALLANMARCA" },
          { text: "CCOCHACCASA" },
          { text: "CHINCHO" },
          { text: "CONGALLA" },
          { text: "HUANCA-HUANCA" },
          { text: "HIJAYLLAY GRANDE" },
          { text: "JULCAMARCA" },
          { text: "LICRAY" },
          { text: "SAN ANTONIO DE ANTAPARCO" },
          { text: "SANTO TOMAS DE PATA" },
          { text: "SECCLLA" },
        ],
        text: "ANGARAES",
      },
      {
        children: [
          { text: "ARMA" },
          { text: "AURAHUA" },
          { text: "CAPILLAS" },
          { text: "CASTROVIRREYNA" },
          { text: "CHUPAMARCA" },
          { text: "COCAS" },
          { text: "HUACHOS" },
          { text: "HUAMATAMBO" },
          { text: "MOLLEPAMPA" },
          { text: "SAN JUAN" },
          { text: "SANTA ANA" },
          { text: "TANTARA" },
          { text: "TICRAPO" },
        ],
        text: "CASTROVIRREYNA",
      },
      {
        children: [
          { text: "ANCO" },
          { text: "CHINCHIHUASI" },
          { text: "CHURCAMPA" },
          { text: "COSME" },
          { text: "EL CARMEN" },
          { text: "LA MERCED" },
          { text: "LOCROJA" },
          { text: "PACHAMARCA" },
          { text: "PAUCARBAMBA" },
          { text: "SAN MIGUEL DE MAYOCC" },
          { text: "SAN PEDRO DE CORIS" },
        ],
        text: "CHURCAMPA",
      },
      {
        children: [
          { text: "ACOBAMBILLA" },
          { text: "ACORIA" },
          { text: "ASCENSION" },
          { text: "CONAYCA" },
          { text: "CUENCA" },
          { text: "HUACHOCOLPA" },
          { text: "HUANCAVELICA" },
          { text: "HUANDO" },
          { text: "HUAYLLAHUARA" },
          { text: "IZCUCHACA" },
          { text: "LARIA" },
          { text: "MANTA" },
          { text: "MARISCAL CACERES" },
          { text: "MOYA" },
          { text: "NUEVO OCCORO" },
          { text: "PALCA" },
          { text: "PILCHACA" },
          { text: "VILCA" },
          { text: "YAULI" },
        ],
        text: "HUANCAVELICA",
      },
      {
        children: [
          { text: "AYAVI" },
          { text: "CORDOVA" },
          { text: "HUAYACUNDO ARMA" },
          { text: "HUAYTARA" },
          { text: "LARAMARCA" },
          { text: "OCOYO" },
          { text: "PILPICHACA" },
          { text: "QUERCO" },
          { text: "QUITO-ARMA" },
          { text: "SAN ANTONIO DE CUSICANCHA" },
          { text: "SAN FRANCISCO DE SANGAYAICO" },
          { text: "SAN ISIDRO" },
          { text: "SANTIAGO DE CHOCORVOS" },
          { text: "SANTIAGO DE QUIRAHUARA" },
          { text: "SANTO DOMINGODE CAPILLAS" },
          { text: "TAMBO" },
        ],
        text: "HUAYTARA",
      },
      {
        children: [
          { text: "ACOSTAMBO" },
          { text: "ACRAQUIA" },
          { text: "AHUAYCHA" },
          { text: "COLCABAMBA" },
          { text: "DANIEL HERNANDEZ" },
          { text: "HUACHOCOLPA" },
          { text: "HUARIBAMBA" },
          { text: "ÑAHUIPUQUIO" },
          { text: "PAMPAS" },
          { text: "PAZOS" },
          { text: "QUISHUAR" },
          { text: "SALCABAMBA" },
          { text: "SALCAHUASI" },
          { text: "SAN MARCOS DE ROCCHAC" },
          { text: "SURCUBAMBA" },
          { text: "TINTAY PUNCU" },
        ],
        text: "TAYACAJA",
      },
    ],
    text: "HUANCAVELICA",
  },
  {
    children: [
      {
        children: [
          { text: "AMBO" },
          { text: "CAYNA" },
          { text: "COLPAS" },
          { text: "CONCHAMARCA" },
          { text: "HUACAR" },
          { text: "SAN FRANCISCO" },
          { text: "SAN RAFAEL" },
          { text: "TOMAY KICHWA" },
        ],
        text: "AMBO",
      },
      {
        children: [
          { text: "CHUQUIS" },
          { text: "LA UNION" },
          { text: "MARIAS" },
          { text: "PACHAS" },
          { text: "QUIVILLA" },
          { text: "RIPAN" },
          { text: "SHUNQUI" },
          { text: "SILLAPATA" },
          { text: "YANAS" },
        ],
        text: "DOS DE MAYO",
      },
      {
        children: [
          { text: "CANCHABAMBA" },
          { text: "COCHABAMBA" },
          { text: "HUACAYBAMBA" },
          { text: "PINRA" },
        ],
        text: "HUACAYBAMBA",
      },
      {
        children: [
          { text: "ARANCAY" },
          { text: "CHAVIN DE PARIARCA" },
          { text: "JACAS GRANDE" },
          { text: "JIRCAN" },
          { text: "LLATA" },
          { text: "MIRAFLORES" },
          { text: "MONZON" },
          { text: "PUNCHAO" },
          { text: "PUÑOS" },
          { text: "SINGA" },
          { text: "TANTAMAYO" },
        ],
        text: "HUAMALIES",
      },
      {
        children: [
          { text: "AMARILIS" },
          { text: "CHINCHAO" },
          { text: "CHURUBAMBA" },
          { text: "HUANUCO" },
          { text: "MARGOS" },
          { text: "PILLCO MARCA" },
          { text: "QUISQUI" },
          { text: "SAN FRANCISCO DE CAYRAN" },
          { text: "SAN PEDRO DE CHAULAN" },
          { text: "SANTA MARIA DEL VALLE " },
          { text: "YACUS" },
          { text: "YARUMAYO" },
        ],
        text: "HUANUCO",
      },
      {
        children: [
          { text: "BAÑOS" },
          { text: "JESUS" },
          { text: "JUIVIA" },
          { text: "QUEROPALCA" },
          { text: "RONDOS" },
          { text: "SAN FRANCISCO DE ASIS" },
          { text: "SAN MIGUEL DE CAURI" },
        ],
        text: "LAURICOCHA",
      },
      {
        children: [
          { text: "DANIEL ALOMIAS ROBLES" },
          { text: "HERMILIO VALDIZAN" },
          { text: "JOSE CRESPO Y CASTILLO" },
          { text: "LUYANDO" },
          { text: "MARIANO DAMASO BERAUN" },
          { text: "RUPA-RUPA" },
        ],
        text: "LEONCIO PRADO",
      },
      {
        children: [
          { text: "CHOLON" },
          { text: "HUACRACHUCO" },
          { text: "SAN BUENAVENTURA" },
        ],
        text: "MARAÑON",
      },
      {
        children: [
          { text: "CHAGLLA" },
          { text: "MOLINO" },
          { text: "PANAO" },
          { text: "UMARI" },
        ],
        text: "PACHITEA",
      },
      {
        children: [
          { text: "CODO DEL POZUZO" },
          { text: "HONORIA" },
          { text: "PUERTO INCA" },
          { text: "TOURNAVISTA" },
          { text: "YUYAPICHIS" },
        ],
        text: "PUERTO INCA",
      },
      {
        children: [
          { text: "APARICIO POMARES" },
          { text: "CAHUAC" },
          { text: "CHACABAMBA" },
          { text: "CHAVINILLO" },
          { text: "CHORAS" },
          { text: "JACAS CHICO" },
          { text: "OBAS" },
          { text: "PAMPAMARCA" },
        ],
        text: "YAROWILCA",
      },
    ],
    text: "HUANUCO",
  },
  {
    children: [
      {
        children: [
          { text: "ALTO LARAN" },
          { text: "CHAVIN" },
          { text: "CHINCHA ALTA" },
          { text: "CHINCHA BAJA" },
          { text: "EL CARMEN" },
          { text: "GROCIO PRADO" },
          { text: "PUEBLO NUEVO" },
          { text: "SAN JUAN DE YANAC" },
          { text: "SAN PEDRO DE HUACARPANA" },
          { text: "SUNAMPE" },
          { text: "TAMBO DE MORA" },
        ],
        text: "CHINCHA",
      },
      {
        children: [
          { text: "ICA" },
          { text: "LA TINGUIÑA" },
          { text: "LOS AQUIJES" },
          { text: "OCUCAJE" },
          { text: "PACHACUTEC" },
          { text: "PARCONA" },
          { text: "PUEBLO NUEVO" },
          { text: "SALAS" },
          { text: "SAN JOSE DE LOS MOLINOS" },
          { text: "SAN JUAN BAUTISTA" },
          { text: "SANTIAGO" },
          { text: "SUBTANJALLA" },
          { text: "TATE" },
          { text: "YAUCA DEL ROSARIO" },
        ],
        text: "ICA",
      },
      {
        children: [
          { text: "CHANGUILLO" },
          { text: "EL INGENIO" },
          { text: "MARCONA" },
          { text: "NAZCA" },
          { text: "VISTA ALEGRE" },
        ],
        text: "NAZCA",
      },
      {
        children: [
          { text: "LLIPATA" },
          { text: "PALPA" },
          { text: "RIO GRANDE" },
          { text: "SANTA CRUZ" },
          { text: "TIBILLO" },
        ],
        text: "PALPA",
      },
      {
        children: [
          { text: "HUANCANO" },
          { text: "HUMAY" },
          { text: "INDEPENDENCIA" },
          { text: "PARACAS" },
          { text: "PISCO" },
          { text: "SAN ANDRES" },
          { text: "SAN CLEMENTE" },
          { text: "TUPAC AMARU INCA" },
        ],
        text: "PISCO",
      },
    ],
    text: "ICA",
  },
  {
    children: [
      {
        children: [
          { text: "CHANCHAMAYO" },
          { text: "PERENE" },
          { text: "PICHANAQUI" },
          { text: "SAN LUIS DE SHUARO" },
          { text: "SAN RAMON" },
          { text: "VITOC" },
        ],
        text: "CHANCHAMAYO",
      },
      {
        children: [
          { text: "AHUAC" },
          { text: "CHONGOS BAJO" },
          { text: "CHUPACA" },
          { text: "HUACHAC" },
          { text: "HUAMANCACA CHICO" },
          { text: "SAN JUAN DE JARRA" },
          { text: "SAN JUAN DE YSCOS" },
          { text: "TRES DE DICIEMBRE" },
          { text: "YANACANCHA" },
        ],
        text: "CHUPACA",
      },
      {
        children: [
          { text: "ACO" },
          { text: "ANDAMARCA" },
          { text: "CHAMBARA" },
          { text: "COCHAS" },
          { text: "COMAS" },
          { text: "CONCEPCION" },
          { text: "HEROINAS TOLEDO" },
          { text: "MANZANARES" },
          { text: "MARISCAL CASTILLA" },
          { text: "MATAHUASI" },
          { text: "MITO" },
          { text: "NUEVE DE JULIO" },
          { text: "ORCOTUNA" },
          { text: "SAN JOSE DE QUERO" },
          { text: "SANTA ROSA DE OCOPA" },
        ],
        text: "CONCEPCION",
      },
      {
        children: [
          { text: "CARHUACALLANGA" },
          { text: "CHACAPAMPA" },
          { text: "CHICCHE" },
          { text: "CHILCA" },
          { text: "CHONGOS ALTO" },
          { text: "CHUPURO" },
          { text: "COLCA" },
          { text: "CULLHUAS" },
          { text: "EL TAMBO" },
          { text: "HUACRAPUQUIO" },
          { text: "HUALHUAS" },
          { text: "HUANCAN" },
          { text: "HUANCAYO" },
          { text: "HUASICANCHA" },
          { text: "HUAYUCACHI" },
          { text: "INGENIO" },
          { text: "PARIAHUANCA" },
          { text: "PILCOMAYO" },
          { text: "PUCARA" },
          { text: "QUICHUAY" },
          { text: "QUILCAS" },
          { text: "SAN AGUSTIN" },
          { text: "SAN JERONIMO DE TUNAN" },
          { text: "SANTO DOMINGO DE ACOBAMBA" },
          { text: "SAÑO" },
          { text: "SAPALLANGA" },
          { text: "SICAYA" },
          { text: "VIQUES" },
        ],
        text: "HUANCAYO",
      },
      {
        children: [
          { text: "ACOLLA" },
          { text: "APATA" },
          { text: "ATAURA" },
          { text: "CANCHAYLLO" },
          { text: "CURICACA" },
          { text: "EL MANTARO" },
          { text: "HUAMALI" },
          { text: "HUARIPAMPA" },
          { text: "HUERTAS" },
          { text: "JANJAILLO" },
          { text: "JAUJA" },
          { text: "JULCAN" },
          { text: "LEONOR ORDOÑEZ" },
          { text: "LLOCLLAPAMPA" },
          { text: "MARCO" },
          { text: "MASMA" },
          { text: "MASMA CHICCHE" },
          { text: "MOLINOS" },
          { text: "MONOBAMBA" },
          { text: "MUQUI" },
          { text: "MUQUIYAUYO" },
          { text: "PACA" },
          { text: "PACCHA" },
          { text: "PANCAN" },
          { text: "PARCO" },
          { text: "POMACANCHA" },
          { text: "RICRAN" },
          { text: "SAN LORENZO" },
          { text: "SAN PEDRO DE CHUNAN" },
          { text: "SAUSA" },
          { text: "SINCOS" },
          { text: "TUNAN MARCA" },
          { text: "YAULI" },
          { text: "YAUYOS" },
        ],
        text: "JAUJA",
      },
      {
        children: [
          { text: "CARHUAMAYO" },
          { text: "JUNIN" },
          { text: "ONDORES" },
          { text: "ULCUMAYO" },
        ],
        text: "JUNIN",
      },
      {
        children: [
          { text: "COVIRIALI" },
          { text: "LLAYLLA" },
          { text: "MAZAMARI" },
          { text: "PAMPA HERMOSA" },
          { text: "PANGOA" },
          { text: "RIO NEGRO" },
          { text: "RIO TAMBO" },
          { text: "SATIPO" },
        ],
        text: "SATIPO",
      },
      {
        children: [
          { text: "ACOBAMBA" },
          { text: "HUARICOLCA" },
          { text: "HUASAHUASI" },
          { text: "LA UNION" },
          { text: "PALCA" },
          { text: "PALCAMAYO" },
          { text: "SAN PEDRO DE CAJAS" },
          { text: "TAPO" },
          { text: "TARMA" },
        ],
        text: "TARMA",
      },
      {
        children: [
          { text: "CHACAPALPA" },
          { text: "HUAY-HUAY" },
          { text: "LA OROYA" },
          { text: "MARCAPOMACOCHA" },
          { text: "MOROCOCHA" },
          { text: "PACCHA" },
          { text: "SANTA BARBARA DE CARHUACAYAN" },
          { text: "SANTA ROSA DE SACCO" },
          { text: "SUITUCANCHA" },
          { text: "YAULI" },
        ],
        text: "YAULI",
      },
    ],
    text: "JUNIN",
  },
  {
    children: [
      {
        children: [
          { text: "ASCOPE" },
          { text: "CASA GRANDE" },
          { text: "CHICAMA" },
          { text: "CHOCOPE" },
          { text: "MAGDALENA DE CAO" },
          { text: "PAIJAN" },
          { text: "RAZURI" },
          { text: "SANTIAGO DE CAO" },
        ],
        text: "ASCOPE",
      },
      {
        children: [
          { text: "BAMBAMARCA" },
          { text: "BOLIVAR" },
          { text: "CONDOMARCA" },
          { text: "LONGOTEA" },
          { text: "UCHUMARCA" },
          { text: "UCUNCHA" },
        ],
        text: "BOLIVAR",
      },
      {
        children: [
          { text: "CHEPEN" },
          { text: "PACANGA" },
          { text: "PUEBLO NUEVO" },
        ],
        text: "CHEPEN",
      },
      {
        children: [
          { text: "CASCAS" },
          { text: "COMPIN" },
          { text: "LUCMA" },
          { text: "SAYAPULLO" },
        ],
        text: "GRAN CHIMU",
      },
      {
        children: [
          { text: "CALAMARCA" },
          { text: "CARABAMBA" },
          { text: "HUASO" },
          { text: "JULCAN" },
        ],
        text: "JULCAN",
      },
      {
        children: [
          { text: "AGALLPAMPA" },
          { text: "CHARAT" },
          { text: "HUARANCHAL" },
          { text: "LA CUESTA" },
          { text: "MACHE" },
          { text: "OTUZCO" },
          { text: "PARANDAY" },
          { text: "SALPO" },
          { text: "SINSICAP" },
          { text: "USQUIL" },
        ],
        text: "OTUZCO",
      },
      {
        children: [
          { text: "GUADALUPE" },
          { text: "JEQUETEPEQUE" },
          { text: "PACASMAYO" },
          { text: "SAN JOSE" },
          { text: "SAN PEDRO DE LLOC" },
        ],
        text: "PACASMAYO",
      },
      {
        children: [
          { text: "BULDIBUYO" },
          { text: "CHILLIA" },
          { text: "HUANCASPATA" },
          { text: "HUAYLILLAS" },
          { text: "HUAYO" },
          { text: "ONON" },
          { text: "PARCOY" },
          { text: "PATAZ" },
          { text: "PIAS" },
          { text: "SANTIAGO DE CHALLAS" },
          { text: "TAURIJA" },
          { text: "TAYABAMBA" },
          { text: "URPAY" },
        ],
        text: "PATAZ",
      },
      {
        children: [
          { text: "CHUGAY" },
          { text: "COCHORCO" },
          { text: "CURGOS" },
          { text: "HUAMACHUCO" },
          { text: "MARCABAL" },
          { text: "SANAGORAN" },
          { text: "SARIN" },
          { text: "SARTIMBAMBA" },
        ],
        text: "SANCHEZ CARRION",
      },
      {
        children: [
          { text: "ANGASMARCA" },
          { text: "CACHICADAN" },
          { text: "MOLLEBAMBA" },
          { text: "MOLLEPATA" },
          { text: "QUIRUVILCA" },
          { text: "SANTA CRUZ DE CHUCA " },
          { text: "SANTIAGO DE CHUCO" },
          { text: "SITABAMBA" },
        ],
        text: "SANTIAGO DE CHUCO",
      },
      {
        children: [
          { text: "EL PORVENIR" },
          { text: "FLORENCIA DE MORA" },
          { text: "HUANCHACO" },
          { text: "LA ESPERANZA" },
          { text: "LAREDO" },
          { text: "MOCHE" },
          { text: "POROTO" },
          { text: "SALAVERRY" },
          { text: "SIMBAL" },
          { text: "TRUJILLO" },
          { text: "VICTOR LARCO HERRERA" },
        ],
        text: "TRUJILLO",
      },
      {
        children: [{ text: "CHAO" }, { text: "GUADALUPITO" }, { text: "VIRU" }],
        text: "VIRU",
      },
    ],
    text: "LA LIBERTAD",
  },
  {
    children: [
      {
        children: [
          { text: "CAYALTI" },
          { text: "CHICLAYO" },
          { text: "CHONGOYAPE" },
          { text: "ETEN" },
          { text: "ETEN PUERTO" },
          { text: "JOSE LEONARDO ORTIZ" },
          { text: "LA VICTORIA" },
          { text: "LAGUNAS" },
          { text: "MONSEFU" },
          { text: "NUEVA ARICA" },
          { text: "OYOTUN" },
          { text: "PATAPO" },
          { text: "PICSI" },
          { text: "PIMENTEL" },
          { text: "POMALCA" },
          { text: "PUCALA" },
          { text: "REQUE" },
          { text: "SANTA ROSA" },
          { text: "SAÑA" },
          { text: "TUMAN" },
        ],
        text: "CHICLAYO",
      },
      {
        children: [
          { text: "CAÑARIS" },
          { text: "FERREÑAFE" },
          { text: "INCAHUASI" },
          { text: "MANUEL ANTONIO MESONES MURO" },
          { text: "PITIPO" },
          { text: "PUEBLO NUEVO" },
        ],
        text: "FERREÑAFE",
      },
      {
        children: [
          { text: "CHOCHOPE" },
          { text: "ILLIMO" },
          { text: "JAYANCA" },
          { text: "LAMBAYEQUE" },
          { text: "MOCHUMI" },
          { text: "MORROPE" },
          { text: "MOTUPE" },
          { text: "OLMOS" },
          { text: "PACORA" },
          { text: "SALAS" },
          { text: "SAN JOSE" },
          { text: "TUCUME" },
        ],
        text: "LAMBAYEQUE",
      },
    ],
    text: "LAMBAYEQUE",
  },
  {
    children: [
      {
        children: [
          { text: "BARRANCA" },
          { text: "PARAMONGA" },
          { text: "PATIVILCA" },
          { text: "SUPE" },
          { text: "SUPE PUERTO" },
        ],
        text: "BARRANCA",
      },
      {
        children: [
          { text: "CAJATAMBO" },
          { text: "COPA" },
          { text: "GORGOR" },
          { text: "HUANCAPON" },
          { text: "MANAS" },
        ],
        text: "CAJATAMBO",
      },
      {
        children: [
          { text: "BELLAVISTA" },
          { text: "CALLAO" },
          { text: "CARMEN DE LA LEGUA REYNOSO" },
          { text: "LA PERLA" },
          { text: "LA PUNTA" },
          { text: "MI PERU" },
          { text: "VENTANILLA" },
        ],
        text: "CALLAO",
      },
      {
        children: [
          { text: "ARAHUAY" },
          { text: "CANTA" },
          { text: "HUAMANTANGA" },
          { text: "HUAROS" },
          { text: "LACHAQUI" },
          { text: "SAN BUENAVENTURA" },
          { text: "SANTA ROSA DE QUIVES" },
        ],
        text: "CANTA",
      },
      {
        children: [
          { text: "ASIA" },
          { text: "CALANGO" },
          { text: "CERRO AZUL" },
          { text: "CHILCA" },
          { text: "COAYLLO" },
          { text: "IMPERIAL" },
          { text: "LUNAHUANA" },
          { text: "MALA" },
          { text: "NUEVO IMPERIAL" },
          { text: "PACARAN" },
          { text: "QUILMANA" },
          { text: "SAN ANTONIO" },
          { text: "SAN LUIS" },
          { text: "SAN VICENTE DE CAÑETE" },
          { text: "SANTA CRUZ DE FLORES" },
          { text: "ZUÑIGA" },
        ],
        text: "CAÑETE",
      },
      {
        children: [
          { text: "ATAVILLOS ALTO" },
          { text: "ATAVILLOS BAJO" },
          { text: "AUCALLAMA" },
          { text: "CHANCAY" },
          { text: "HUARAL" },
          { text: "IHUARI" },
          { text: "LAMPIAN" },
          { text: "PACARAOS" },
          { text: "SAN MIGUEL DE ACOS" },
          { text: "SANTA CRUZ DE ANDAMARCA" },
          { text: "SUMBILCA" },
          { text: "VEINTISIETE DE NOVIEMBRE" },
        ],
        text: "HUARAL",
      },
      {
        children: [
          { text: "ANTIOQUIA" },
          { text: "CALLAHUANCA" },
          { text: "CARAMPOMA" },
          { text: "CHICLA" },
          { text: "CUENCA" },
          { text: "HUACHUPAMPA" },
          { text: "HUANZA" },
          { text: "HUAROCHIRI" },
          { text: "LAHUAYTAMBO" },
          { text: "LANGA" },
          { text: "LARAOS" },
          { text: "MARIANATA" },
          { text: "MATUCANA" },
          { text: "RICARDO PALMA" },
          { text: "SAN ANDRES DE TUPICOCHA" },
          { text: "SAN ANTONIO" },
          { text: "SAN BARTOLOME" },
          { text: "SAN DAMIAN" },
          { text: "SAN JUAN DE IRIS" },
          { text: "SAN JUAN DE TANTARANCHE" },
          { text: "SAN LORENZO DE QUINTI" },
          { text: "SAN MATEO" },
          { text: "SAN MATEO DE OTAO" },
          { text: "SAN PEDRO DE CASTA" },
          { text: "SAN PEDRO DE HUANCAYRE" },
          { text: "SANGALLAYA" },
          { text: "SANTA CRUZ DE COCHACRA" },
          { text: "SANTA EULALIA" },
          { text: "SANTIAGO DE ANCHUCAYA" },
          { text: "SANTIAGO DE TUNA" },
          { text: "SANTO DOMINGO DE LOS OLLEROS" },
          { text: "SURCO" },
        ],
        text: "HUAROCHIRI",
      },
      {
        children: [
          { text: "AMBAR" },
          { text: "CALETA DE CARQUIN" },
          { text: "CHECRAS" },
          { text: "HUACHO" },
          { text: "HUALMAY" },
          { text: "HUAURA" },
          { text: "LEONCIO PRADO" },
          { text: "PACCHO" },
          { text: "SANTA LEONOR" },
          { text: "SANTA MARIA" },
          { text: "SAYAN" },
          { text: "VEGUETA" },
        ],
        text: "HUARA",
      },
      {
        children: [
          { text: "ANCON" },
          { text: "ATE" },
          { text: "BARRANCO" },
          { text: "BREÑA" },
          { text: "CARABAYLLO" },
          { text: "CHACLACAYO" },
          { text: "CHORRILLOS" },
          { text: "CIENEGUILLA" },
          { text: "COMAS" },
          { text: "EL AGUSTINO" },
          { text: "INDEPENDENCIA" },
          { text: "JESUS MARIA" },
          { text: "LA MOLINA" },
          { text: "LA VICTORIA" },
          { text: "LIMA" },
          { text: "LINCE" },
          { text: "LOS OLIVOS" },
          { text: "LURIGANCHO" },
          { text: "LURIN" },
          { text: "MAGDALENA DEL MAR" },
          { text: "MAGDALENA VIEJA" },
          { text: "MIRAFLORES" },
          { text: "PACHACAMAC" },
          { text: "PUCUSANA" },
          { text: "PUEBLO LIBRE" },
          { text: "PUENTE PIEDRA" },
          { text: "PUNTA HERMOSA" },
          { text: "PUNTA NEGRA" },
          { text: "RIMAC" },
          { text: "SAN BARTOLO" },
          { text: "SAN BORJA" },
          { text: "SAN ISIDRO" },
          { text: "SAN JUAN DE LURIGANCHO" },
          { text: "SAN JUAN DE MIRAFLORES" },
          { text: "SAN LUIS" },
          { text: "SAN MARIN DE PORRES" },
          { text: "SAN MIGUEL" },
          { text: "SANTA ANITA" },
          { text: "SANTA MARIA DEL MAR" },
          { text: "SANTA ROSA" },
          { text: "SANTIAGO DE SURCO" },
          { text: "SURQUILLO" },
          { text: "VILLA SALVADOR" },
          { text: "VILLA MARIA DEL TRIUNFO" },
        ],
        text: "LIMA",
      },
      {
        children: [
          { text: "ANDAJES" },
          { text: "CAUJUL" },
          { text: "COCHAMARCA" },
          { text: "NAVAN" },
          { text: "OYON" },
          { text: "PACHANGARA" },
        ],
        text: "OYON",
      },
      {
        children: [
          { text: "ALIS" },
          { text: "AYAUCA" },
          { text: "AYAVIRI" },
          { text: "AZANGARO" },
          { text: "CACRA" },
          { text: "CARANIA" },
          { text: "CATAHUASI" },
          { text: "CHOCOS" },
          { text: "COCHAS" },
          { text: "COLONIA" },
          { text: "HONGOS" },
          { text: "HUAMPARA" },
          { text: "HUANCAYA" },
          { text: "HUANGASCAR" },
          { text: "HUANTAN" },
          { text: "HUAÑEC" },
          { text: "LARAOS" },
          { text: "LINCHA" },
          { text: "MADEAN" },
          { text: "MIRAFLORES" },
          { text: "OMAS" },
          { text: "PUTINZAS" },
          { text: "QUINCHES" },
          { text: "QUINOCAY" },
          { text: "SAN JOAQUIN" },
          { text: "SAN PEDRO DE PILAS" },
          { text: "TANTA" },
          { text: "TAURIPAMPA" },
          { text: "TOMAS" },
          { text: "TUPE" },
          { text: "VIÑAC" },
          { text: "VITIS" },
          { text: "YAUYOS" },
        ],
        text: "YAUYOS",
      },
    ],
    text: "LIMA",
  },
  {
    children: [
      {
        children: [
          { text: "BALSAPUERTO" },
          { text: "JEBEROS" },
          { text: "LAGUNAS" },
          { text: "SANTA CRUZ" },
          { text: "TENIENTE CESAR LOPEZ" },
          { text: "YURIMAGUAS" },
        ],
        text: "ALTO AMAZONAS",
      },
      {
        children: [
          { text: "ANDOAS" },
          { text: "BARRANCA" },
          { text: "CAHUAPANAS" },
          { text: "MARSERICHE" },
          { text: "MORONA" },
          { text: "PASTAZA" },
        ],
        text: "DATEM DEL MARAÑON",
      },
      {
        children: [
          { text: "NAUTA" },
          { text: "PARINARI" },
          { text: "TIGRE" },
          { text: "TROMPETEROS" },
          { text: "URARINAS" },
        ],
        text: "LORETO",
      },
      {
        children: [
          { text: "PEBAS" },
          { text: "RAMON CASTILLA" },
          { text: "SAN PABLO" },
          { text: "YAVARI" },
        ],
        text: "MARISCAL RAMON CASTILLA",
      },
      {
        children: [
          { text: "ALTO NANAY" },
          { text: "BELEN" },
          { text: "FERNANDO DE LORES" },
          { text: "INDIANA" },
          { text: "IQUITOS" },
          { text: "LAS AMAZONAS" },
          { text: "MAZAN" },
          { text: "NAPO" },
          { text: "PUNCHANA" },
          { text: "PUTUMAYO" },
          { text: "SAN JUAN BAUTISTA" },
          { text: "TENIENTE MANUEL CLAVERO" },
          { text: "TORRES CAUSANA" },
        ],
        text: "MAYNAS",
      },
      {
        children: [
          { text: "ALTO TRAPICHE" },
          { text: "CAPELO" },
          { text: "EMILIO SAN MARTIN" },
          { text: "JENARO HERRERA" },
          { text: "MAQUIA" },
          { text: "PUINAHUA" },
          { text: "REQUENA" },
          { text: "SAQUENA" },
          { text: "SOPLIN" },
          { text: "TAPICHE" },
          { text: "YAQUERANA" },
        ],
        text: "REQUENA",
      },
      {
        children: [
          { text: "CONTAMANA" },
          { text: "INAHUAYA" },
          { text: "PADRE MARQUEZ" },
          { text: "PAMPA HERMOSA" },
          { text: "SARAYACU" },
          { text: "VARGAS GUERRA" },
        ],
        text: "UCAYALI",
      },
    ],
    text: "LORETO",
  },
  {
    children: [
      {
        children: [
          { text: "FITZCARRALD" },
          { text: "HUEPETUHE" },
          { text: "MADRE DE DIOS" },
          { text: "MANU" },
        ],
        text: "MANU",
      },
      {
        children: [
          { text: "IBERIA" },
          { text: "IÑAPARI" },
          { text: "TAHUAMANU" },
        ],
        text: "TAHUAMANU",
      },
      {
        children: [
          { text: "INAMBARI" },
          { text: "LABERINTO" },
          { text: "LAS PIEDRAS" },
          { text: "TAMBOPATA" },
        ],
        text: "TAMBOPATA",
      },
    ],
    text: "MADRE DE DIOS",
  },
  {
    children: [
      {
        children: [
          { text: "CHOJATA" },
          { text: "COALAQUE" },
          { text: "ICHUÑA" },
          { text: "LA CAPILLA" },
          { text: "LLOQUE" },
          { text: "MATALAQUE" },
          { text: "OMATE" },
          { text: "PUQUINA" },
          { text: "QUINISTAQUILLAS" },
          { text: "UBINAS" },
          { text: "YUNGA" },
        ],
        text: "GENERAL SANCHEZ CERRO",
      },
      {
        children: [
          { text: "EL ALGARROBINAL" },
          { text: "ILO" },
          { text: "PACOCHA" },
        ],
        text: "ILO",
      },
      {
        children: [
          { text: "CARUMAS" },
          { text: "CUCHUMBAYA" },
          { text: "MOQUEGUA" },
          { text: "SAMEGUA" },
          { text: "SAN CRISTOBAL" },
          { text: "TORATA" },
        ],
        text: "MARISCAL NIETO",
      },
    ],
    text: "MOQUEGUA",
  },
  {
    children: [
      {
        children: [
          { text: "CHACAYAN" },
          { text: "GOYLLARISQUIZGA" },
          { text: "PAUCAR" },
          { text: "SAN PEDRO DE PILLAO" },
          { text: "SANTA ANA DE TUSI" },
          { text: "TAPUC" },
          { text: "VILCABAMBA" },
          { text: "YANAHUANCA" },
        ],
        text: "DANIEL ALCIDES CARRION",
      },
      {
        children: [
          { text: "CHONTABAMBA" },
          { text: "HUANCABAMBA" },
          { text: "OXAPAMPA" },
          { text: "PALCAZU" },
          { text: "POZUZO" },
          { text: "PUERTO BERMUDEZ" },
          { text: "VILLA RICA" },
        ],
        text: "OXAPAMPA",
      },
      {
        children: [
          { text: "CHAUPIMARCA" },
          { text: "HUACHON" },
          { text: "HUARIACA" },
          { text: "HUAYLLAY" },
          { text: "NINACA" },
          { text: "PALLANCHACRA" },
          { text: "PAUCARTAMBO" },
          { text: "SAN FRANCISCO DE ASIS DE YARUSYACAN" },
          { text: "SIMON BOLIVAR" },
          { text: "TICLACAYAN" },
          { text: "TINYAHUARCO" },
          { text: "VICCO" },
          { text: "YANACANCHA" },
        ],
        text: "PASCO",
      },
    ],
    text: "PASCO",
  },
  {
    children: [
      {
        children: [
          { text: "AYABACA" },
          { text: "FRIAS" },
          { text: "JILILI" },
          { text: "LAGUNAS" },
          { text: "MONTERO" },
          { text: "PACAIPAMPA" },
          { text: "PAIMAS" },
          { text: "SAPILLICA" },
          { text: "SICCHEZ" },
          { text: "SUYO" },
        ],
        text: "AYABACA",
      },
      {
        children: [
          { text: "CANCHAQUE" },
          { text: "EL CARMEN DE LA FRONTERA" },
          { text: "HUANCABAMBA" },
          { text: "HUARMACA" },
          { text: "LALAQUIZ" },
          { text: "SAN MIGUEL DE EL FAIQUE" },
          { text: "SONDOR" },
          { text: "SONDORILLO" },
        ],
        text: "HUANCABAMBA",
      },
      {
        children: [
          { text: "BUENOS AIRES" },
          { text: "CHALACO" },
          { text: "CHULUCANAS" },
          { text: "LA MATANZA" },
          { text: "MORROPON" },
          { text: "SALITRAL" },
          { text: "SAN JUAN DE BIGOTE" },
          { text: "SANTA CATALINA DE MOSSA" },
          { text: "SANTO DOMINGO" },
          { text: "YAMANGO" },
        ],
        text: "MORROPON",
      },
      {
        children: [
          { text: "AMOTAPE" },
          { text: "ARENAL" },
          { text: "COLAN" },
          { text: "LA HUACA" },
          { text: "PAITA" },
          { text: "TAMARINDO" },
          { text: "VICHAYAL" },
        ],
        text: "PAITA",
      },
      {
        children: [
          { text: "CASTILLA" },
          { text: "CATACAOS" },
          { text: "CURA MORI" },
          { text: "EL TALLAN" },
          { text: "LA ARENA" },
          { text: "LA UNION" },
          { text: "LAS LOMAS" },
          { text: "PIURA" },
          { text: "TAMBO GRANDE" },
        ],
        text: "PIURA",
      },
      {
        children: [
          { text: "BELLAVISTA DE LA UNION" },
          { text: "BERNAL" },
          { text: "CRISTO NOS VALGA" },
          { text: "RINCONADA LLICUAR" },
          { text: "SECHURA" },
          { text: "VICE" },
        ],
        text: "SECHURA",
      },
      {
        children: [
          { text: "BELLAVISTA" },
          { text: "IGNACIO ESCUDERO" },
          { text: "LANCONES" },
          { text: "MARCAVELICA" },
          { text: "MIGUEL CHECA" },
          { text: "QUERECOTILLO" },
          { text: "SALITRAL" },
          { text: "SULLANA" },
        ],
        text: "SULLANA",
      },
      {
        children: [
          { text: "EL ALTO" },
          { text: "LOS ORGANOS" },
          { text: "MANCORA" },
          { text: "LA BREA" },
          { text: "PARIÑAS" },
          { text: "LOBITOS" },
        ],
        text: "TALARA",
      },
    ],
    text: "PIURA",
  },
  {
    children: [
      {
        children: [
          { text: "ACHAYA" },
          { text: "ARAPA" },
          { text: "ASILLO" },
          { text: "AZANGARO" },
          { text: "CAMINACA" },
          { text: "CHUPA" },
          { text: "JOSE DOMINGO CHOQUEHUANCA" },
          { text: "MUÑANI" },
          { text: "POTONI" },
          { text: "SAMAN" },
          { text: "SAN ANTON" },
          { text: "SAN JOSE" },
          { text: "SAN JUAN DE SALINAS" },
          { text: "SANTIAGO DE PUPUJA" },
          { text: "TIRAPATA" },
        ],
        text: "AZANGARO",
      },
      {
        children: [
          { text: "AJOYANI" },
          { text: "AYAPATA" },
          { text: "COASA" },
          { text: "CORANI" },
          { text: "CRUCERO" },
          { text: "ITUATA" },
          { text: "MACUSANI" },
          { text: "OLLACHEA" },
          { text: "SAN GABAN" },
          { text: "USICAYOS" },
        ],
        text: "CARABAYA",
      },
      {
        children: [
          { text: "DESAGUADERO" },
          { text: "HUACULLANI" },
          { text: "JULI" },
          { text: "KELLUYO" },
          { text: "PISACOMA" },
          { text: "POMATA" },
          { text: "ZEPITA" },
        ],
        text: "CHUCUITO",
      },
      {
        children: [
          { text: "CAPAZO" },
          { text: "CONDURIRI" },
          { text: "ILAVE" },
          { text: "PILCUYO" },
          { text: "SANTA ROSA" },
        ],
        text: "EL COLLAO",
      },
      {
        children: [
          { text: "COJATA" },
          { text: "HUANCANE" },
          { text: "HUATASANI" },
          { text: "INCHUPALLA" },
          { text: "PUSI" },
          { text: "ROSASPATA" },
          { text: "TARACO" },
          { text: "VILQUE CHICO" },
        ],
        text: "HUANCANE",
      },
      {
        children: [
          { text: "CABANILLA" },
          { text: "CALAPUJA" },
          { text: "LAMPA" },
          { text: "NICASIO" },
          { text: "OCUVIRI" },
          { text: "PALCA" },
          { text: "PARATIA" },
          { text: "PUCARA" },
          { text: "SANTA LUCIA" },
          { text: "VILAVILA" },
        ],
        text: "LAMPA",
      },
      {
        children: [
          { text: "ANTAUTA" },
          { text: "AYAVIRI" },
          { text: "CUPI" },
          { text: "LLALLI" },
          { text: "MACARI" },
          { text: "NUÑOA" },
          { text: "ORURILLO" },
          { text: "SANTA ROSA" },
          { text: "UMACHIRI" },
        ],
        text: "MELGAR",
      },
      {
        children: [
          { text: "CONIMA" },
          { text: "HUAYRAPATA" },
          { text: "MOHO" },
          { text: "TILALI" },
        ],
        text: "MOHO",
      },
      {
        children: [
          { text: "ACORA" },
          { text: "AMANTANI" },
          { text: "ATUNCOLLA" },
          { text: "CAPACHICA" },
          { text: "CHUCUITO" },
          { text: "COATA" },
          { text: "HUATA" },
          { text: "MAÑAZO" },
          { text: "PAUCARCOLLA" },
          { text: "PICHACANI" },
          { text: "PLATERIA" },
          { text: "PUNO" },
          { text: "SAN ANTONIO" },
          { text: "TIQUILLACA" },
          { text: "VILQUE" },
        ],
        text: "PUNO",
      },
      {
        children: [
          { text: "ANANEA" },
          { text: "PUTINA" },
          { text: "PEDRO VILCA APAZA" },
          { text: "QUILCAPUNCU" },
          { text: "SINA" },
        ],
        text: "SAN ANTONIO DE PUTINA",
      },
      {
        children: [
          { text: "ALTO INAMBARI" },
          { text: "CUYOCUYO" },
          { text: "LIMBANI" },
          { text: "PATAMBUCO" },
          { text: "PHARA" },
          { text: "QUIACA" },
          { text: "SAN JUAN DEL ORO" },
          { text: "SAN PEDRO DE PUTINA PUNCO" },
          { text: "SANDIA" },
          { text: "YANAHUAYA" },
        ],
        text: "SANDIA",
      },
      {
        children: [
          { text: "CABANA" },
          { text: "CABANILLAS" },
          { text: "CARACOTO" },
          { text: "JULIACA" },
        ],
        text: "SAN ROMAN",
      },
      {
        children: [
          { text: "ANAPIA" },
          { text: "COPANI" },
          { text: "CUTURAPI" },
          { text: "OLLARAYA" },
          { text: "TINICACHI" },
          { text: "UNICACHI" },
          { text: "YUNGUYO" },
        ],
        text: "YUNGUYO",
      },
    ],
    text: "PUNO",
  },
  {
    children: [
      {
        children: [
          { text: "ALTO BIAVO" },
          { text: "BAJO BIAVO" },
          { text: "BELLAVISTA" },
          { text: "HUALLAGA" },
          { text: "SAN PABLO" },
          { text: "SAN RAFAEL" },
        ],
        text: "BELLAVISTA",
      },
      {
        children: [
          { text: "AGUA BLANCA" },
          { text: "SAN JOSE DE SISA" },
          { text: "SAN MARTIN" },
          { text: "SANTA ROSA" },
          { text: "SHATOJA" },
        ],
        text: "EL DORADO",
      },
      {
        children: [
          { text: "ALTO SAPOSOA" },
          { text: "EL ESLABON" },
          { text: "PISCOYACU" },
          { text: "SACANCHE" },
          { text: "SAPOSOA" },
          { text: "TINGO DE SAPOSOA" },
        ],
        text: "HUALLAGA",
      },
      {
        children: [
          { text: "ALONSO DE ALVARADO" },
          { text: "BARRANQUITA" },
          { text: "CAYNARACHI" },
          { text: "CUÑUMBUQUI" },
          { text: "LAMAS" },
          { text: "PINTO RECODO" },
          { text: "RUMISAPA" },
          { text: "SAN ROQUE DE CUMBAZA" },
          { text: "SHANAO" },
          { text: "TABALOSOS" },
          { text: "ZAPATERO" },
        ],
        text: "LAMAS",
      },
      {
        children: [
          { text: "CAMPANILLA" },
          { text: "HUINCUNGO" },
          { text: "JUANJI" },
          { text: "PACHIZA" },
          { text: "PAJARILLO" },
        ],
        text: "MARISCAL CACERES",
      },
      {
        children: [
          { text: "CALZADA" },
          { text: "HABANA" },
          { text: "JEPELACIO" },
          { text: "MOYOBAMBA" },
          { text: "SORITOR" },
          { text: "YANTALO" },
        ],
        text: "MOYOBAMBA",
      },
      {
        children: [
          { text: "BUENOS AIRES" },
          { text: "CASPISAPA" },
          { text: "PICOTA" },
          { text: "PILLUANA" },
          { text: "PUCACACA" },
          { text: "SAN CRISTOBAL" },
          { text: "SAN HILARION" },
          { text: "SHAMBOYACU" },
          { text: "TINGO DE PONASA" },
          { text: "TRES UNIDOS" },
        ],
        text: "PICOTA",
      },
      {
        children: [
          { text: "AWAJUN" },
          { text: "ELIAS SOPLIN VARGAS" },
          { text: "NUEVA CAJAMARCA" },
          { text: "PARDO MIGUEL" },
          { text: "POSIC" },
          { text: "RIOJA" },
          { text: "SAN FERNANDO" },
          { text: "YORONGOS" },
          { text: "YURACYACU" },
        ],
        text: "RIOJA",
      },
      {
        children: [
          { text: "ALBERTO LEVEAU" },
          { text: "CACATACHI" },
          { text: "CHATUZA" },
          { text: "CHIPURANA" },
          { text: "EL PROVENIR" },
          { text: "HUIMBAYOC" },
          { text: "JUAN GUERRA" },
          { text: "LA BANDA DE SHILCAYO" },
          { text: "MORALES" },
          { text: "PAPAPLAYA" },
          { text: "SAN ANTONIO" },
          { text: "SAUCE" },
          { text: "SHAPAJA" },
          { text: "TARAPOTO" },
        ],
        text: "SAN MARTIN",
      },
      {
        children: [
          { text: "NUEVO PROGRESO" },
          { text: "POLVORA" },
          { text: "SHUNTE" },
          { text: "TOCACHE" },
          { text: "UCHIZA" },
        ],
        text: "TOCACHE",
      },
    ],
    text: "SAN MARTIN",
  },
  {
    children: [
      {
        children: [
          { text: "CAIRANI" },
          { text: "CAMILACA" },
          { text: "CANDARAVE" },
          { text: "CURIBAYA" },
          { text: "HUANUARA" },
          { text: "QUILAHUANI" },
        ],
        text: "CANDARAVE",
      },
      {
        children: [{ text: "ILABAYA" }, { text: "ITE" }, { text: "LOCUMBA" }],
        text: "JORGE BASADRE",
      },
      {
        children: [
          { text: "ALTO DE ALIANZA" },
          { text: "CALANA" },
          { text: "CIUDAD NUEVA" },
          { text: "CORONEL GREGORIO ALBARRACIN LANCHIPA" },
          { text: "INCLAN" },
          { text: "PACHIA" },
          { text: "PALCA" },
          { text: "POCOLLAY" },
          { text: "SAMA" },
          { text: "TACNA" },
        ],
        text: "TACNA",
      },
      {
        children: [
          { text: "ESTIQUE" },
          { text: "ESTIQUE-PAMPA" },
          { text: "HEROES ALBARRACIN" },
          { text: "SITAJARA" },
          { text: "SUSAPAYA" },
          { text: "TARATA" },
          { text: "TARUCACHI" },
          { text: "TICACO" },
        ],
        text: "TARATA",
      },
    ],
    text: "TACNA",
  },
  {
    children: [
      {
        children: [
          { text: "CANOAS DE PUNTA SAL" },
          { text: "CASITAS" },
          { text: "ZORRITOS" },
        ],
        text: "CONTRALMIRANTE VILLAR",
      },
      {
        children: [
          { text: "CORRALES" },
          { text: "LA CRUZ" },
          { text: "PAMPAS DE HOSPITAL" },
          { text: "SAN JACINTO" },
          { text: "SAN JUAN DE LA VIRGEN" },
          { text: "TUMBES" },
        ],
        text: "TUMBES",
      },
      {
        children: [
          { text: "AGUAS VERDES" },
          { text: "MATAPALO" },
          { text: "PAPAYAL" },
          { text: "ZARUMILLA" },
        ],
        text: "ZARUMILLA",
      },
    ],
    text: "TUMBES",
  },
  {
    children: [
      {
        children: [
          { text: "RAYMONDI" },
          { text: "SEPAHUA" },
          { text: "TAHUANIA" },
          { text: "YURUA" },
        ],
        text: "ATALAYA",
      },
      {
        children: [
          { text: "CALLERIA" },
          { text: "CAMPOVERDE" },
          { text: "IPARI" },
          { text: "MASISEA" },
          { text: "NUEVA REQUENA" },
          { text: "PUCALLPA" },
          { text: "YARINACOCHA" },
        ],
        text: "CORONEL PORTILLO",
      },
      {
        children: [
          { text: "CURIMANA" },
          { text: "IRAZOLA" },
          { text: "PADRE ABAD" },
        ],
        text: "PADRE ABAD",
      },
      { children: [{ text: "PURUS" }], text: "PURUS" },
    ],
    text: "UCAYALI",
  },
];

// 收入
export const wageGradeList = [
  {
    text: "Menos que 700 PEN",
    value: 1,
  },
  {
    text: "701-1150 PEN",
    value: 2,
  },
  {
    text: "1151-1600 PEN",
    value: 3,
  },
  {
    text: "1601-2050 PEN",
    value: 4,
  },
  {
    text: "2051-2500 PEN",
    value: 5,
  },
  {
    text: "Más que 2500 PEN",
    value: 6,
  },
];

// 学历信息
export const getEduList = [
  {
    text: "Maestría o Doctorado",
    value: 1,
  },
  {
    text: "Licenciatura",
    value: 2,
  },
  {
    text: "Bachillerado",
    value: 3,
  },
  {
    text: "Secundaria",
    value: 4,
  },
  {
    text: "Primaria",
    value: 5,
  },
  {
    text: "Otros",
    value: 6,
  },
];

// 联系人信息
export const getContactTypeList = [
  {
    text: "Esposo/a",
    value: 1,
  },
  {
    text: "Padres",
    value: 2,
  },
  {
    text: "Hermano/a",
    value: 3,
  },
  {
    text: "Hijo/a",
    value: 4,
  },
];

// 联系人2信息
export const getContactTypeList2 = [
  {
    text: "Esposo/a",
    value: 1,
  },
  {
    text: "Padres",
    value: 2,
  },
  {
    text: "Hermano/a",
    value: 3,
  },
  {
    text: "Hijo/a",
    value: 4,
  },
  {
    text: "Amigos",
    value: 5,
  },
];
